/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Customer_Group_Page_TitleInputs */

const vi_customer_group_page_title = /** @type {(inputs: Customer_Group_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quản lý nhóm khách hàng`)
};

/**

* @param {Customer_Group_Page_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const customer_group_page_title = /** @type {((inputs?: Customer_Group_Page_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Customer_Group_Page_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_customer_group_page_title(inputs)
});